import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

interface HeaderCellStylesProps {
    isSortedBy?: boolean;
}

export const headerCellStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            padding: theme.spacing("19px", "12px", "15px", "12px"),
            color: theme.colors.neutrals.neutral500,
            borderBottomColor: theme.colors.neutrals.neutral500,
        },

        icon: {
            fill: ({ isSortedBy }: HeaderCellStylesProps) =>
                isSortedBy
                    ? theme.colors.neutrals.neutral500
                    : theme.colors.neutrals.neutral300,
            width: "12px",
            marginLeft: "5px",
        },

        typography: {
            fontSize: "12px",
            lineHeight: "14px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.03em",
        },

        button: {
            color: theme.colors.neutrals.neutral500,

            "&:hover": {
                background: "transparent",
            },

            "& > span": {
                display: "flex",
                alignItems: "stretch",
            },
        },
    })
);
